import { FormattedMessage, useIntl } from "react-intl";

import Button from "@atlaskit/button-next/new";
import Heading from "@atlaskit/heading";
import { Box, Stack, Text } from "@atlaskit/primitives-next";

import { ErrorVector } from "../../assets";

import { messages } from "./messages";

export type GenericErrorDisplayProps = {
    customMessage?: string;
    refreshButtonLabel?: string;
    onRefresh?: () => void;
};

export const GenericErrorDisplay = ({
    customMessage,
    refreshButtonLabel,
    onRefresh
}: GenericErrorDisplayProps) => {
    const intl = useIntl();

    const buttonLabel =
        refreshButtonLabel ||
        intl.formatMessage(messages.defaultRefreshButtonLabel);

    return (
        <Box padding="space.400">
            <Stack alignBlock="center" space="space.200" alignInline="center">
                <ErrorVector
                    alt={intl.formatMessage(
                        messages.genericErrorGraphicAltText
                    )}
                />
                <Heading size="medium">
                    <FormattedMessage {...messages.genericErrorHeading} />
                </Heading>
                {customMessage && <Text>{customMessage}</Text>}
                {onRefresh && (
                    <Button appearance="primary" onClick={onRefresh}>
                        {buttonLabel}
                    </Button>
                )}
            </Stack>
        </Box>
    );
};
